import { Link } from "react-router-dom";

export default function MadnessMenu() {
  return (
    <div style={{ textAlign: "center", padding: 40 }}>
      <h1 style={{ fontSize: "2rem", marginBottom: 20 }}>🎮 NUBBI MADNESS</h1>
      <p style={{ fontSize: "1.1rem", marginBottom: 30 }}>Choose your battle format</p>

      <div style={{ display: "flex", flexDirection: "column", gap: 20, alignItems: "center" }}>
        <Link to="/madness/top" style={btn("#4F46E5")}>🏆 Top 64 Madness</Link>
        <Link to="/madness/random" style={btn("#10B981")}>🔀 Random Nubbi Madness</Link>
        <Link to="/madness/multi" style={btn("#F59E0B")}>🌐 Multiverse Madness</Link>
      </div>
    </div>
  );
}

const btn = (bg) => ({
  backgroundColor: bg,
  color: "#fff",
  textDecoration: "none",
  padding: "14px 20px",
  borderRadius: 12,
  fontSize: "1rem",
  fontWeight: "bold",
  minWidth: 250,
});